<ng-container *ngIf="isReady$ | async; else loadingTmpl">
  <rd-core-main-container #container>
    <rd-westpac-bypass-block
      bypass-block
      [isLoggedIn]="container.isLoggedIn$ | async"></rd-westpac-bypass-block>
    <rd-westpac-header
      main-header
      role="header"
      aria-label="site header"
      tabindex="-1"></rd-westpac-header>
    <rd-westpac-footer main-footer></rd-westpac-footer>
  </rd-core-main-container>
</ng-container>

<ng-template #loadingTmpl>
  <div class="flex h-screen w-screen items-center justify-center">
    <rd-shared-spinner></rd-shared-spinner>
  </div>
</ng-template>
